import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../algorithms/styleDirection";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Button from "../sharedComponents/buttons/button";
import "../tasks/tasksStyle.css";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  editMilestoneForm,
  getAllProjectStatus,
} from "../../API/store/actions/projects/projects";

const EditMilestone = (props) => {
  const { onHide, setProjAdded, projAdded, milestoneId, data } = props;

  const [MilestoneDropdownList, setMilestoneDropdownList] = useState([]);
  const [milestoneObj, setMilestoneObj] = useState({});
  const [dropdowns, setDrobdowns] = useState({});
  const userToken = useSelector((state) => state.login.userToken);

  useEffect(() => {
    resolver(getAllProjectStatus, setMilestoneObj, userToken);
  }, []);

  useEffect(() => {
    if (milestoneObj?.data?.statusLkp)
      setMilestoneDropdownList(milestoneObj?.data?.statusLkp);
  }, [milestoneObj]);

  const saveHandler = async (values) => {
    let formData = new FormData();
    const newData = {
      Name: values.Name,
      Id: milestoneId,
      Description: values.Description,
      ProjectStatusId: parseInt(values.ProjectStatusId),
    };

    for (let [key, value] of Object.entries(newData)) {
      formData.append(key, value);
    }

    let res = await editMilestoneForm(formData, userToken);
    if (res.status <= 206) {
      setProjAdded(!projAdded);
      onHide();
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      data,
      validationSchema,
      "editMilestone",
      saveHandler
    )
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;

  if (dropdowns && data)
    return (
      <Modal
        // show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center mx-4">
              <img
                src="/assets/images/greeniconedit.svg"
                width={20}
                height={20}
                alt=""
              />
              <div className="text-dark">
                <p
                  className="my-0 mx-1"
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "#1a73e8",
                  }}
                >
                  {Lang.editMilestone}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <form onSubmit={handleSubmit}>
            <TextArea
              name={"Name"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.title + "*"}
              value={values.Name}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Name")}
            />

            <TextArea
              name={"Description"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.Description + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              value={values.Description}
              errorMessage={formikValidation(touched, errors, "Description")}
            />

            <div className="d-flex flex-xl-row justify-content-center align-items-center col-12 flex-column mb-4">
              <DropDownList
                placeholder={Lang.status + "*"}
                border={true}
                containerStyle={"col-12 mb-3 my-xl-0 px-xl-5 px-4"}
                dataSource={MilestoneDropdownList}
                value={values.ProjectStatusId}
                change={(e) => {
                  setFieldValue("ProjectStatusId", e.value);
                }}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "ProjectStatusId"
                )}
              />
            </div>

            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                content={Lang.save}
                containerStyle="col-3 mx-3"
                type={"submit"}
                buttonStyleType={"solid"}
              />

              <Button
                content={Lang.cancel}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  onHide();
                }}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  return null;
};
export default EditMilestone;
